<template>
  <v-card>
    <v-card-title>
      Item Logs

      <div class="flex-grow-1"></div>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filter"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-card-text>
        <v-data-table
          v-if="propLogs"
          :headers="propHeaders"
          :items="propLogs"
          :search="search"
          class="elevation-1"
          item-key="id"
          show-expand
          sort-by="createdAt"
          sort-desc>
          <template v-slot:item.Tags="{ item }">
            <v-chip-group>
              <v-chip class="mt-1 teal" v-for="tag in item.Tags" :key="tag.id" @click="goToTag">{{ tag.name }}</v-chip>
            </v-chip-group>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <br>
              <pre>Log ID: {{ item.id }}</pre>
              <br>
              <pre>Item before: {{ item.oldItem }}</pre>
              <br>
              <pre>Item after: {{ item.newItem }}</pre>
              <br>
              <pre>Difference: {{ JSON.parse(item.diff) }}</pre>
              <br>
              <pre>Notes: {{ item.notes }}</pre>
              <br>
              <pre>Tags: {{ item.Tags.map(tag => {return tag.name}) }}</pre>
              <br>
              <pre>Performing User: {{ item.performingUser }}</pre>
              <br>
              <pre>Created: {{ item.createdAt }}</pre>
              <br>
            </td>
          </template>
        </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ItemLogs',

  props: ['propHeaders', 'propLogs'],

  data: () => ({
    search: ''
  }),

  methods: {
    goToTag (tag) {
      console.log('clicked tag:', tag)
    }
  }
}
</script>
